import { CartResultUnconfirmedError } from '~/modules/checkout/composables/useCart/cartCoordinator';
import type { Cart, SetShippingMethodsOnCartInput } from '~/modules/GraphQL/types';
import { CustomHeaders, CustomQuery, UseContextReturn } from '~/types/core';

export const setShippingMethodsOnCartCommand = {
  execute: async (
    context: UseContextReturn,
    shippingMethodParams: SetShippingMethodsOnCartInput,
    customQuery: CustomQuery,
    customHeaders: CustomHeaders,
  ): Promise<Cart | null> => {
    const { data, errors } = await context.app.$vsf.$magento.api.setShippingMethodsOnCart(shippingMethodParams, customQuery, customHeaders);

    // TODO: Find out why 'Cart' doesn't match the type of the response data.
    // The adapter's generated type omits fields selected by our custom query.
    // Assert the shared type only at this boundary, then validate below.
    const cart = data?.setShippingMethodsOnCart?.cart as unknown as Cart;
    if (errors?.length) {
      if (cart) throw new CartResultUnconfirmedError(errors[0]?.message);
      throw new Error(errors[0]?.message || 'Unable to set shipping method');
    }
    if (!cart?.shipping_addresses?.[0] || cart.id !== shippingMethodParams.cart_id || !cart.prices
      || !Array.isArray(cart.available_payment_methods)) throw new CartResultUnconfirmedError();
    return cart;
  },
};
